import { render, staticRenderFns } from "./Promised.vue?vue&type=template&id=3b7b4cf5&"
import script from "./Promised.vue?vue&type=script&lang=js&"
export * from "./Promised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports